import React from 'react'

const CheckboxCheckedIcon = () => {
    return (
        <span style={{display:"flex"}}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="2" width="20" height="20" rx="4" fill="currentColor"/>
                <path d="M18.0728 8.92865L11.0028 15.9996L6.75977 11.7566L8.17377 10.3426L11.0028 13.1716L16.6588 7.51465L18.0728 8.92865Z" fill="white"/>
            </svg>
        </span>
    )
}

export default CheckboxCheckedIcon;